RivalIQ.apps.Overview.module('curations', function (curations, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;
    const widgetTypes = RivalIQ.enums.widgetTypes;


    const PdfLayout = Dashboard.views.ExportWidgets.extend({
        childView: Dashboard.views.ColumnWidgets.extend({
            columnBootstrapSize: function () {
                const me = this;

                if (me.dashboardModel.isExportingPNG()) {
                    return 'sm';
                } else {
                    return 'lg';
                }
            },

            afterAppendRow: function (child, elBuffer) {
                const me = this;
                if (me.dashboardModel.isExportingPDF() && child.dashboardModel.widgetId === widgetTypes.SECTION_HEADER) {
                    $(elBuffer.lastChild).addClass('page-break-before section-header-pdf-panel');
                }
            }
        })
    });

    curations.Leaderboard = Dashboard.models.Curation.mixin({
        mixins: {
            ExportHD: Dashboard.mixins.ExportHD,
            ChannelSwitchable: Dashboard.mixins.ChannelSwitchable,
            curationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy
        },

        beforeFilters: [
            Dashboard.curations.filters.channelWall
        ],

        getExportTitle: function () {
            const me = this;

            const channelName = RivalIQ.data.channels.get(me.getProp('channel')).get('name');
            return `${channelName} Leaderboard`;
        },

        widgetDefinitions: function () {
            const me = this;

            const channel = me.getProp('channel');

            const timeSeriesDimensions = _.compact(['timeAnalysisMode', 'companyId', 'day', (channel ? 'channel' : null)]);

            // In cross-channel, channel is the free-dimension (i.e., what we're going to show in the legend). In single channel,
            // we can show engagement_type in the legend.
            const engagementTotalDimensions = _.compact(['timeAnalysisMode', 'companyId', 'channel', (channel ? 'engagement_type' : null)]);

            // For delta rels, we don't want a free dimension other than companyId.
            const secondaryMetricDimensions = _.compact(['timeAnalysisMode', 'companyId', (channel ? 'channel' : null)]);

            const activityDimensions = ['timeAnalysisMode', 'companyId', 'channel'];
            let activityMetricProperty = 'count';
            if (channel === RivalIQ.enums.channels.TWITTER) {
                activityDimensions.push('tweetType');
                activityMetricProperty = 'all_count';
            }

            const channelName = RivalIQ.data.channels.get(channel).get('name');
            let audienceName;
            let audienceNameSingular;

            let audienceSectionHeader;
            let activitySectionHeader;
            const engagementSectionHeader = 'Engagement Leaderboard';
            const postName = _.upperFirst(RivalIQ.data.channels.get(channel).get('postName'));
            const postsName = `${postName}s`;
            let activityName = postName.toLowerCase();
            if (channel) {
                audienceName = RivalIQ.metric.names.metricName({
                    property: 'presence_reach',
                    channel: channel,
                    dimensions: ['channel']
                });
                audienceNameSingular = audienceName.slice(0, audienceName.length - 1);
                audienceSectionHeader = `${audienceName} Leaderboard`;

                activitySectionHeader = `${postsName} Leaderboard`;
            } else {
                activityName = 'activity';
                audienceName = audienceNameSingular = 'Audience';
                audienceSectionHeader = 'Audience Leaderboard';
                activitySectionHeader = 'Activity Leaderboard';
            }

            const widgets = [

                {
                    instanceId: 'audience-section-header',
                    widgetId: RivalIQ.enums.widgetTypes.SECTION_HEADER,
                    props: {
                        anchorName: 'audience',
                        columnWidth: 12,
                        sectionHeaderName: audienceSectionHeader
                    }
                },
                {
                    instanceId: 'presence_reach',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
                    descriptionOptions: {
                        omitTimeAnalysisModeDescription: true,
                        name: false
                    },
                    props: {
                        columnWidth: 6,
                        showBenchmarkLine: true,
                        metrics: [
                            {
                                property: 'audience',
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                                dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                            }
                        ],
                        secondary: {
                            property: 'audience',
                            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                            dimensions: secondaryMetricDimensions
                        },
                        title: `${channelName} ${audienceName}`
                    }
                },
                {
                    instanceId: 'presence_reach_delta',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART,
                    descriptionOptions: {
                        omitTimeAnalysisModeDescription: true,
                        name: false
                    },
                    description: RivalIQ.str('leaderboard_audience_net_change_description', audienceName.toLowerCase(), audienceNameSingular.toLowerCase(), audienceNameSingular.toLowerCase()),
                    props: {
                        columnWidth: 6,
                        showBenchmarkLine: true,
                        metrics: [
                            {
                                property: 'presence_reach',
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE,
                                dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                            }
                        ],
                        title: `${channelName} ${audienceName} Net Change`,
                        showMessageOnDataNotAvailable: true,
                        beforeTimePeriodName: 'comparePeriodEnd'
                    }
                },
                {
                    instanceId: 'activity-section-header',
                    widgetId: RivalIQ.enums.widgetTypes.SECTION_HEADER,
                    props: {
                        anchorName: 'activity',
                        columnWidth: 12,
                        sectionHeaderName: activitySectionHeader
                    }
                },
                {
                    instanceId: 'activity',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
                    descriptionOptions: {
                        omitTimeAnalysisModeDescription: true,
                        name: false
                    },
                    props: {
                        columnWidth: 6,
                        showBenchmarkLine: true,
                        metrics: [
                            {
                                property: activityMetricProperty,
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                                dimensions: activityDimensions
                            }
                        ],
                        secondary: {
                            property: activityMetricProperty,
                            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                            dimensions: secondaryMetricDimensions
                        },
                        renderBarPatterns: Boolean(channel),
                        title: `${channelName} ${postsName}`
                    }
                },
                {
                    instanceId: 'activity-over-time',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_COMPANY_LINE_CHART,
                    props: {
                        columnWidth: 6,
                        showBenchmarkLine: true,
                        useAutoTimeInterval: true,
                        addTimeIntervalToTitle: true,
                        focusCompany: me.getProp('focusCompanyId'),
                        description: RivalIQ.str('leaderboard_activity_over_time_description', activityName),
                        metrics: [
                            {
                                property: 'count',
                                dimensions: timeSeriesDimensions,
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                            }
                        ]
                    }
                },

                {
                    instanceId: 'engagement-section-header',
                    widgetId: RivalIQ.enums.widgetTypes.SECTION_HEADER,
                    props: {
                        anchorName: 'engagement',
                        columnWidth: 12,
                        sectionHeaderName: engagementSectionHeader
                    }
                },
                {
                    instanceId: 'engagement-total',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
                    descriptionOptions: {
                        omitTimeAnalysisModeDescription: true,
                        name: false
                    },
                    props: {
                        columnWidth: 6,
                        showBenchmarkLine: true,
                        metrics: [
                            {
                                property: 'engagement_total',
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                                dimensions: engagementTotalDimensions
                            }
                        ],
                        secondary: {
                            property: 'engagement_total',
                            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                            dimensions: secondaryMetricDimensions
                        },
                        renderBarPatterns: Boolean(channel),
                        title: `${channelName} Engagement Total`
                    }
                },
                {
                    instanceId: 'engagement-over-time',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_COMPANY_LINE_CHART,
                    props: {
                        columnWidth: 6,
                        showBenchmarkLine: true,
                        useAutoTimeInterval: true,
                        addTimeIntervalToTitle: true,
                        focusCompany: me.getProp('focusCompanyId'),
                        description: RivalIQ.strings.leaderboard_engagement_over_time_description,
                        metrics: [
                            {
                                property: 'engagement_total',
                                dimensions: timeSeriesDimensions,
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD
                            }
                        ]
                    }
                },
                {
                    instanceId: 'engagement-total-per-post',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
                    descriptionOptions: {
                        omitTimeAnalysisModeDescription: true,
                        name: false
                    },
                    props: {
                        columnWidth: 6,
                        showBenchmarkLine: true,
                        metrics: [
                            {
                                property: 'engagement_total_per_post',
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                                dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                            }
                        ],
                        secondary: {
                            property: 'engagement_total_per_post',
                            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                            dimensions: secondaryMetricDimensions
                        },
                        title: `${channelName} Engagement Total / ${postName}`
                    }
                }
            ];

            if (channel) {
                // Engagement rate only makes sense for a single channel.
                const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';
                widgets.push({
                    instanceId: 'avg_engagement_rate_per_post',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
                    descriptionOptions: {
                        omitTimeAnalysisModeDescription: true,
                        name: false
                    },
                    props: {
                        columnWidth: 6,
                        showBenchmarkLine: true,
                        metrics: [
                            {
                                property: 'avg_engagement_rate_per_post',
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                                dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                            }
                        ],
                        secondary: {
                            property: 'avg_engagement_rate_per_post',
                            timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                            dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                        },
                        title: `${channelName} Engagement Rate by ${audienceName}`
                    }
                });

                if (channel === RivalIQ.enums.channels.TIKTOK || channel === RivalIQ.enums.channels.YOUTUBE) {
                    widgets.push(
                        {
                            instanceId: 'views-section-header',
                            widgetId: RivalIQ.enums.widgetTypes.SECTION_HEADER,
                            props: {
                                anchorName: 'views',
                                columnWidth: 12,
                                sectionHeaderName: 'Views Leaderboard'
                            }
                        },
                        {
                            instanceId: 'views',
                            widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
                            descriptionOptions: {
                                omitTimeAnalysisModeDescription: true,
                                name: false
                            },
                            props: {
                                columnWidth: 6,
                                showBenchmarkLine: true,
                                metrics: [
                                    {
                                        property: 'views',
                                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                                        dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                                    }
                                ],
                                secondary: {
                                    property: 'views',
                                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                                    dimensions: secondaryMetricDimensions
                                }
                            }
                        },
                        {
                            instanceId: 'engagement-rate-by-view',
                            widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
                            descriptionOptions: {
                                omitTimeAnalysisModeDescription: true,
                                name: false
                            },
                            props: {
                                columnWidth: 6,
                                showBenchmarkLine: true,
                                metrics: [
                                    {
                                        property: 'engagement_total_per_view',
                                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                                        dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                                    }
                                ],
                                secondary: {
                                    property: 'engagement_total_per_view',
                                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                                    dimensions: ['timeAnalysisMode', 'companyId', 'channel']
                                }
                            }
                        });
                }

            } else {
                // add in the a chart for the applicable engagement types for cross-channel
                const engagementTypes = RivalIQ.data.channels.get(channel).get('engagementTypes');
                _.each(engagementTypes, function (engagementType) {
                    widgets.push({
                        instanceId: engagementType,
                        widgetId: RivalIQ.enums.widgetTypes.METRIC_BAR_CHART_WITH_CHANGE,
                        descriptionOptions: {
                            omitTimeAnalysisModeDescription: true,
                            name: false
                        },
                        props: {
                            columnWidth: 6,
                            showBenchmarkLine: true,
                            metrics: [
                                {
                                    property: 'engagement_total',
                                    engagement_type: engagementType,
                                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                                    dimensions: ['timeAnalysisMode', 'companyId', 'engagement_type', 'channel']
                                }
                            ],
                            secondary: {
                                property: 'engagement_total',
                                engagement_type: engagementType,
                                timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                                dimensions: ['timeAnalysisMode', 'companyId', 'engagement_type']
                            },
                            title: `${channelName} ${_.upperFirst(engagementType)}`
                        }
                    });
                });
            }


            return widgets;
        },

        widgetsView: App.views.CurationWidgetsLayoutWithBenchmarkChooser,
        exportWidgetsView: PdfLayout,

        getSwitchableTitleView: function (options) {
            const me = this;
            const title = me.getSwitchableTitle();
            const collectionItems = me.getSwitchableItems();

            if (_.size(collectionItems) <= 1) {
                return me.getTitle();
            }
            return new RivalIQ.views.TitleDropdown({
                model: new Backbone.Model(_.extend({
                    name: title
                }, options)),
                collection: new Backbone.Collection(collectionItems)
            });
        },

        getSwitchableItems: function () {
            const me = this;

            const allChannels = Dashboard.mixins.ChannelSwitchable.getSwitchableItems.apply(me);

            const instanceId = me.getProp('instanceId');

            const channel = me.getProp('channel');
            if (!channel) {
                const engagementTypes = RivalIQ.data.channels.get(channel).get('engagementTypes');

                // the cross-channel engagement metrics are only applicable to cross-channel
                if (_.includes(engagementTypes, instanceId)) {
                    return _.filter(allChannels, function (channel) {
                        return _.isUndefined(channel.value);
                    });
                }
            }

            if (channel && instanceId === 'avg_engagement_rate_per_post') {
                // avg_engagement_rate_per_post only makes sense for individual channels.
                return _.reject(allChannels, function (channel) {
                    return _.isUndefined(channel.value);
                });
            }

            return allChannels;
        },


        processProps: function (props) {
            props.useUniversalMetricsApi = true;

            return props;
        },

        validCurationOptions: ['channel'],

        getPath: function (overrides) {
            const me = this;

            return Dashboard.models.Curation.prototype.getPath.call(me, _.extend({
                channel: me.getProp('channel')
            }, overrides));
        },

        getBackPath: function (widgetProps) {
            const me = this;
            const filteredProps = _.pick(widgetProps, me.validCurationOptions);
            return me.getBasePath(filteredProps);
        },

        getBasePath: function (props) {
            const me = this;

            props = _.extend({
                channel: me.getProp('channel')
            }, props);
            return me.router.resolveCurationRoute(me.id, props);
        },


        getViewTrackingOptions: function () {
            const me = this;

            const viewTracking = Dashboard.models.Curation.prototype.getViewTrackingOptions.apply(me, arguments);
            if (me.isFocus()) {
                const scrollToSection = me.getProp('scrollToSection');
                if (scrollToSection) {
                    viewTracking.panelType = scrollToSection;
                    viewTracking.ref = 'overview-link';
                }
            }

            return viewTracking;
        },

        getCurationViewTrackingId: _.constant('charts')
    });
});
